import { createFileRoute, redirect } from '@tanstack/react-router';
import { activeConfig } from '@/config';
import HomePage from '@/components/pages/home';

export const Route = createFileRoute('/')({
  head: () => ({
    meta: [{ title: `Sign In | ${activeConfig.branding.appName}` }],
  }),
  beforeLoad: ({ context }) => {
    if (!context.auth.isLoading && context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: HomePage,
});
